import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { IAttribute } from '@dxp/core/models';
import { RbacApiService } from '@dxp/core/api';

@Injectable({
    providedIn: 'root',
})
export class AttributesService {
    readonly #rbacApiService = inject(RbacApiService);

    getAgentAttributes(agentId: string): Observable<IAttribute[]> {
        return this.#rbacApiService.getAgentAttributes(agentId).pipe(
            catchError(() => {
                return of([]);
            }),
        );
    }

    getAllAgentAttributes(): Observable<string[]> {
        return this.#rbacApiService.getAllAgentAttributes().pipe(
            catchError(() => {
                return of([]);
            }),
        );
    }

    updateAgentAttributes(agentId: string, attributes: IAttribute[]) {
        return this.#rbacApiService.updateAgentAttributes(agentId, attributes);
    }
}
